<style src="./RegisterEmployee.scss" lang="scss"></style>
<template>
  <div class="wrapper wrapper-content animated fadeIn">
    <div class="row">
      <div class="col-lg-3">
        <div class="ibox float-e-margins">
          <div class="ibox-content mailbox-content">
            <form v-on:submit.prevent="createRegister">
              <h2>Cadastro de Usuários</h2>
              <div class="space-25"></div>

              <div class="form-group">
                <label>Nome Completo</label>
                <input
                  type="text"
                  placeholder="João da Silva"
                  class="form-control"
                  v-model="registerForm.form.fullName"
                />
              </div>

              <div class="form-group">
                <label>Telefone</label>
                <input
                  type="text"
                  placeholder="(21) 99887-6655"
                  v-mask="'(##) #####-####'"
                  class="form-control"
                  v-model="registerForm.form.cellPhone"
                />
              </div>

              <div class="form-group">
                <label>E-Mail</label>
                <input
                  type="text"
                  placeholder="meuemail@gmail.com"
                  class="form-control"
                  v-model="registerForm.form.email"
                />
              </div>

              <div class="form-group">
                <label>Identificador</label>
                <input
                  type="text"
                  placeholder="987.654.321-00"
                  class="form-control"
                  v-model="registerForm.form.cpf"
                />
              </div>

              <div class="form-group">
                <label>Senha</label>
                <input
                  type="password"
                  placeholder="Informe uma senha"
                  class="form-control"
                  v-model="registerForm.form.password"
                />
              </div>

              <div class="form-group">
                <label>Nível de acesso</label>
                <select class="form-control" v-model="registerForm.form.role">
                  <option
                    v-for="(item, idx) in registerForm.control.roleList"
                    :key="idx"
                    :value="item.id"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </div>
              <div class="form-group">
                <label>Tipo de Usuário</label>
                <select
                  class="form-control"
                  v-model="registerForm.form.userType"
                >
                  <option
                    v-for="(item, idx) in registerForm.control.userTypeList"
                    :key="idx"
                    :value="item.value"
                  >
                    {{ item.label }}
                  </option>
                </select>
              </div>

              <button
                class="btn btn-block btn-primary compose-mail"
                href="mail_compose.html"
                :disabled="
                  registerForm.control.createButtonIsDisabled ||
                    !permissionUpdate
                "
                v-if="!registerForm.control.editModeId"
              >
                <i class="fa fa-save"></i>
                Criar Usuário
              </button>

              <div v-if="registerForm.control.editModeId">
                <button
                  class="btn btn-outline"
                  href="mail_compose.html"
                  :disabled="registerForm.control.createButtonIsDisabled"
                  @click="disableEditMode"
                >
                  Cancelar
                </button>

                <button
                  class="btn btn-warning pull-right"
                  href="mail_compose.html"
                  :disabled="
                    registerForm.control.createButtonIsDisabled ||
                      !permissionUpdate
                  "
                  @click="saveEdition"
                >
                  <i class="fa fa-save"></i>
                  Salvar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div class="col-lg-9 animated fadeInRight">
        <div class="mail-box-header">
          <h2>Lista de Usuários</h2>

          <form>
            <div class="input-group">
              <input
                type="text"
                class="form-control"
                v-model="searchForm.form.fullName"
              />

              <div class="input-group-btn">
                <button
                  type="button"
                  class="btn btn-sm btn-primary"
                  @click="searchRegister"
                  v-if="permissionRead"
                >
                  <i class="fa fa-search"></i>
                  Buscar
                </button>
              </div>
            </div>
          </form>
          <br />
          <div>
            <button
              type="button"
              class="btn btn-sm btn-primary"
              @click="toggleEnables"
            >
              <i class="fa fa-filter"></i>
              <span> {{ justEnables ? 'Todos' : 'Habilitados' }} </span>
            </button>
          </div>
        </div>
        <div class="mail-box">
          <table class="table table-hover table-mail">
            <thead class="table-head">
              <tr>
                <th>Nome Completo</th>
                <th>Identificador</th>
                <th>Telefone</th>
                <th></th>
                <th></th>
              </tr>
            </thead>

            <tbody class="table-list">
              <tr
                :class="{ unread: listItem.accountEnabled }"
                v-for="(listItem, listIdx) in registerList.list"
                :key="listIdx"
              >
                <td>{{ listItem.fullName }}</td>
                <td>{{ listItem.cpf }}</td>
                <td>{{ listItem.cellPhone }}</td>
                <td class="list-command">
                  <button
                    class="btn btn-outline"
                    @click="enterEditMode(listItem, listIdx)"
                    v-if="permissionUpdate"
                  >
                    <i class="fa fa-edit text-success"></i>
                  </button>
                </td>
                <td class="list-command">
                  <button
                    class="btn btn-outline"
                    title="Inabilitar funcionário"
                    v-if="listItem.accountEnabled && permissionUpdate"
                    @click="disableEmployee(listItem)"
                  >
                    <i class="fa fa-unlock text-success"></i>
                  </button>

                  <button
                    class="btn btn-outline"
                    title="Habilitar funcionário"
                    v-if="!listItem.accountEnabled && permissionUpdate"
                    @click="enableEmployee(listItem)"
                  >
                    <i class="fa fa-lock text-danger"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mask } from 'vue-the-mask';
import { SHA256 } from 'crypto-js';
import { toast } from '@/plugins/toast';

export default {
  name: 'RegisterEmployee',
  directives: { mask },
  data() {
    return {
      justEnables: false,
      registerForm: {
        form: {
          fullName: '',
          cellPhone: '',
          email: '',
          cpf: '',
          password: '',
          role: null,
          userType: 'user',
        },
        control: {
          editModeId: false,
          createButtonIsDisabled: false,
          roleList: [],
          userTypeList: [
            {
              label: 'Atendente',
              value: 'user',
            },
            {
              label: 'Ponto de Venda',
              value: 'pdv',
            },
            {
              label: 'Parquímetro',
              value: 'parking-meter',
            },
            {
              label: 'Agente',
              value: 'agent',
            },
            {
              label: 'Cabine',
              value: 'cabine',
            },
            {
              label: 'Serpro',
              value: 'serpro',
            },
            {
              label: 'QR Pix',
              value: 'qrpix',
            },
          ],
        },
      },
      searchForm: {
        form: {
          fullName: '',
        },
        control: {},
      },
      registerList: {
        originalList: [],
        list: [],
        control: {},
      },
    };
  },
  computed: {
    permissionCreate() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'register-employee',
        'CREATE',
      );
    },
    permissionRead() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'register-employee',
        'READ',
      );
    },
    permissionUpdate() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'register-employee',
        'UPDATE',
      );
    },
    permissionDelete() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'register-employee',
        'DELETE',
      );
    },
  },
  watch: {
    'searchForm.form.fullName'() {
      this.searchRegister();
    },
  },
  mounted() {
    this.listEmployers();
    this.listRoles();
  },
  methods: {
    async listRoles() {
      const list = await this.$store.dispatch('ROLES/ListRoles');
      this.registerForm.control.roleList = list;
    },
    async listEmployers() {
      if (!this.permissionRead) {
        return;
      }
      const employeeList = await this.$store.dispatch(
        'EMPLOYEE/GetEmployeeList',
      );
      this.registerList.originalList = employeeList;
      this.searchRegister();
    },
    searchRegister() {
      if (!this.permissionRead) {
        return;
      }

      const listFiltered = this.registerList.originalList.filter(item => {
        const nameFilter =
          item.fullName
            .toUpperCase()
            .indexOf(this.searchForm.form.fullName.toUpperCase()) > -1;
        const accountEnabledFilter = this.justEnables
          ? item.accountEnabled
          : item.accountEnabled || !item.accountEnabled;

        return nameFilter && accountEnabledFilter;
      });
      this.registerList.list = listFiltered;
    },
    async createRegister() {
      if (!this.permissionCreate) {
        return;
      }

      this.registerForm.control.createButtonIsDisabled = true;
      const password = SHA256(this.registerForm.form.password).toString();

      const payload = {
        ...this.registerForm.form,
        password,
      };

      try {
        await this.$store.dispatch('EMPLOYEE/CreateNewEmployee', payload);
        this.listEmployers();

        this.registerForm.form.fullName = '';
        this.registerForm.form.cellPhone = '';
        this.registerForm.form.email = '';
        this.registerForm.form.cpf = '';
        this.registerForm.form.password = '';
        this.registerForm.form.role = null;
        this.registerForm.form.userType = null;

        toast.success('Usuário inserido com sucesso');
      } catch (error) {
        toast.error(error.error);
      } finally {
        this.registerForm.control.createButtonIsDisabled = false;
      }
    },
    enterEditMode(registerItem) {
      this.registerForm.control.editModeId = registerItem._id;
      this.registerForm.form.fullName = registerItem.fullName;
      this.registerForm.form.cellPhone = registerItem.cellPhone;
      this.registerForm.form.email = registerItem.email;
      this.registerForm.form.cpf = registerItem.cpf;
      this.registerForm.form.password = '';
      this.registerForm.form.userType = registerItem.userType;
      this.registerForm.form.role = registerItem.role;
    },
    disableEditMode() {
      this.registerForm.control.editModeId = false;
      this.registerForm.form.fullName = '';
      this.registerForm.form.cellPhone = '';
      this.registerForm.form.email = '';
      this.registerForm.form.cpf = '';
      this.registerForm.form.password = '';
      this.registerForm.form.role = null;
      this.registerForm.form.userType = null;
    },
    async saveEdition() {
      this.registerForm.control.createButtonIsDisabled = true;

      const userId = this.registerForm.control.editModeId;

      const payload = {
        ...this.registerForm.form,
      };
      if (this.registerForm.form.password.trim() !== '') {
        const password = SHA256(this.registerForm.form.password).toString();
        payload.password = password;
      } else {
        delete payload.password;
      }

      try {
        await this.$store.dispatch('EMPLOYEE/UpdateEmployee', {
          payload,
          userId,
        });
        this.listEmployers();

        this.registerForm.form.fullName = '';
        this.registerForm.form.cellPhone = '';
        this.registerForm.form.email = '';
        this.registerForm.form.cpf = '';
        this.registerForm.form.password = '';
        this.registerForm.form.role = null;

        toast.success('Usuário salvo com sucesso');
      } catch (error) {
        toast.error(error.error);
      } finally {
        this.registerForm.control.createButtonIsDisabled = false;
      }
    },
    async disableEmployee({ _id }) {
      try {
        const payload = { accountEnabled: false };
        const userId = _id;

        await this.$store.dispatch('EMPLOYEE/UpdateEmployee', {
          payload,
          userId,
        });
        this.listEmployers();
        toast.success('Usuário desabilitado com sucesso');
      } catch (error) {
        toast.error(error.error);
      }
    },
    async enableEmployee({ _id }) {
      try {
        const payload = { accountEnabled: true };
        const userId = _id;

        await this.$store.dispatch('EMPLOYEE/UpdateEmployee', {
          payload,
          userId,
        });
        this.listEmployers();
        toast.success('Usuário desabilitado com sucesso');
      } catch (error) {
        toast.error(error.error);
      }
    },
    toggleEnables() {
      this.justEnables = !this.justEnables;
      this.searchRegister();
    },
  },
};
</script>
